<template>
  <div class="Box">
    <!-- <Echarts/> -->
    <el-row class="Center">
      <el-col class="borde">
        <div>
          <el-col class="bordeLeft" :span="2">待确认</el-col>
          <el-col class="bordeLeft" :span="18">
            <el-radio-group
              v-model="radio3"
              size="small"
              @change="handleRadioChange"
            >
              <el-radio-button label="100;101;102">全部</el-radio-button>
              <el-radio-button label="101">待换票方确认</el-radio-button>
              <el-radio-button label="100">待后台确认</el-radio-button>
              <el-radio-button label="102">待接单方确认</el-radio-button>
            </el-radio-group>
          </el-col>
        </div>
      </el-col>
    </el-row>
    <!-- table -->
    <div class="table">
      <el-row>
        <el-col :span="24">
          <el-col :span="24" class="Bot" v-loading="false">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="tableHeaderColor"
            >
              <el-table-column label="序号" min-width="5%" type="index">
              </el-table-column>
              <el-table-column
                prop="createTime"
                min-width="12%"
                label="发布时间"
              >
              </el-table-column>
              <el-table-column
                prop="orderId"
                label="订单号"
                min-width="10%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column prop="billNum" label="票据号码" min-width="10%">
              </el-table-column>
              <el-table-column
                prop="acceptingBank"
                label="承兑人"
                min-width="10%"
              >
              </el-table-column>
              <el-table-column prop="billAmt" label="票面金额" min-width="10%">
              </el-table-column>
              <el-table-column prop="endDate" label="到期日" min-width="7%">
              </el-table-column>
              <el-table-column prop="acceptType" label="类型" min-width="5%">
              </el-table-column>
              <el-table-column prop="cmpName" label="需求方" min-width="10%">
              </el-table-column>
              <el-table-column
                prop="channelName"
                label="资金方"
                min-width="10%"
              >
              </el-table-column>
              <el-table-column prop="status" label="订单状态" min-width="6%">
                <template slot-scope="scope">
                  <div v-if="scope.row.status == 100">待后台确认</div>
                  <div v-if="scope.row.status == 101">待换票方确认</div>
                  <div v-if="scope.row.status == 102">待接单方确认</div>
                </template>
              </el-table-column>
              <el-table-column prop="zip" label="操作" min-width="12%">
                <template slot-scope="scope">
                  <div>
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        更多操作<i
                          class="el-icon-arrow-down el-icon--right"
                        ></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-if="scope.row.status == 100"
                          @click.native="handleClick(scope.row.orderId)"
                          >补充信息</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="scope.row.status == 100"
                          @click.native="handleDel(scope.row)"
                          >关闭订单</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="scope.row.status == 100"
                          @click.native="handleGets(scope.row.orderId)"
                          >指派订单</el-dropdown-item
                        >
                        <el-dropdown-item
                          @click.native="handleRowClick(scope.row.orderId)"
                          >查看详情</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <!-- pagination -->
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :page-size="pagesize"
        :total="this.totalPage"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="请选择派单用户"
      :visible.sync="dialogV"
      :before-close="handleClose"
      width="380px"
    >
      <div class="mnv">
        <el-col class="dodos" :span="6">手机号:</el-col
        ><el-col :span="18"
          ><el-input
            v-model="inputVal"
            :maxlength="11"
            placeholder="请输入手机号"
            @blur="handleSearCom"
          ></el-input
        ></el-col>
      </div>
      <div class="mnv">
        <el-col class="dodos" :span="6">公司名称:</el-col
        ><el-col :span="18"
          ><el-input v-model="comsVal" placeholder="公司名称"></el-input
        ></el-col>
      </div>
      <div class="bud">
        <el-button type="primary" class="butg" @click="submitForm()"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="补充订单信息"
      :visible.sync="dialogMesg"
      :before-close="handleClose"
      width="580px"
    >
      <div class="mnv qwe">
        <el-col class="dodovv" :span="7">直客意向金:</el-col
        ><el-col :span="16"
          ><el-input
            v-model="moneyone"
            :maxlength="11"
            placeholder="请输入直客意向金"
            @blur="handleSearCom"
          ></el-input
        ></el-col>
      </div>
      <div class="mnv zxc">
        <el-col class="dodovv" :span="7">中介保证金&差额(元):</el-col
        ><el-col :span="8"
          ><el-input
            v-model="moneytwo"
            placeholder="中介保证金"
          ></el-input></el-col
        ><el-col :span="8"
          ><el-input v-model="moneytre" placeholder="差额"></el-input
        ></el-col>
      </div>
      <div class="mnv zxc">
        <el-col class="dodovv" :span="7">票据类型:</el-col
        ><el-col :span="8">
          <el-select v-model="Selvalue" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </div>
      <div class="mnv zxc">
        <el-col class="dodovv" :span="7">换票需求:</el-col
        ><el-col :span="16"
          ><el-input
            v-model="textVal"
            placeholder="换票需求"
            type="textarea"
            :rows="2"
          ></el-input
        ></el-col>
      </div>
      <div class="bud">
        <el-button type="primary" class="butg" @click="changeClick()"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      testData: [
        {
          orderNumber: "1",
          channelNumber: "4223",
          billNumber: "O2020022842231430123",
          orderStatus: "已打款",
          transferor: "杭州某某有限公司可换行",
          assignee: "北京某某有限公司可换行",
          reciteTime: "2.5小时",
          overTime: "00:03:34",
          times: "1",
          visible: false,
        },
      ],
      showCon: true,
      tableData: [],
      dialogV: false,
      inputVal: "",
      comsVal: "",
      solvedId: "",
      totalPage: 0,
      currentPage: 1,
      pagesize: 10,
      radio3: "100;101;102",
      getId: "",
      msgid: "",
      uuid: "",
      custNo: "",
      dialogMesg: false,
      Selvalue: "",
      textVal: "",
      moneytre: "",
      moneytwo: "",
      moneyone: "",
      options: [
        {
          value: "国股",
          label: "国股",
        },
        {
          value: "大商",
          label: "大商",
        },
        {
          value: "城商",
          label: "城商",
        },
        {
          value: "三农",
          label: "三农",
        },
        {
          value: "村镇",
          label: "村镇",
        },
        {
          value: "外贸",
          label: "外贸",
        },
        {
          value: "财票",
          label: "财票",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.handleAjax(this.currentPage);
  },
  methods: {
    handleCurrentChange(val) {
      this.handleAjax();
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: rgba(244,244,244,1);color: rgba(51,51,51,1);font-weight: bold;font-size:14px; height:55px;";
      }
    },
    handleRadioChange(val) {
      this.handleAjax();
    },

    handleAjax() {
      this.loading = true;
      this.ajax
        .post("/jyOder/changeOrderList", {
          bizContent: {
            currentPage: this.currentPage,
            pageSize: this.pagesize,
            statusType: this.radio3,
            merchCode: "",
          },
        })
        .then((result) => {
          if (result.data.status == "0000") {
            let add = result.data.data.data;
            add.map((item, index) => {
              add[index].xh = index + 1;
            });
            this.tableData = add;
            this.totalPage = result.data.data.total;
            this.loading = false;
          } else {
          }
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.inputVal = "";
          this.comsVal = "";
          this.handleAjax();
        })
        .catch((_) => {});
    },
    handleRowClick(val) {
      this.$router.push({
        name: "Exchangeinfo",
        query: {
          oId: val,
        },
      });
    },
    handleClick(val) {
      this.msgid = val;
      this.ajax
        .post("/jyOder/jyPiaoDetail", { bizContent: { orderId: val } })
        .then((result) => {
          if (result.data.status == "0000") {
            let add = result.data.data;
            this.moneyone = add.sellGuarantee;
            this.moneytwo = add.buyGuarantee;
            this.moneytre = add.difference;
            this.Selvalue = add.accepttype;
            this.textVal = add.demand;
            this.dialogMesg = !this.dialogMesg;
          } else {
          }
        });
    },
    handleGets(val) {
      this.getId = val;
      this.dialogV = !this.dialogV;
    },
    handleSearCom() {
      this.ajax
        .post("/jyOder/getcompanybyphone", {
          bizContent: { phone: this.inputVal },
        })
        .then((result) => {
          if (result.data.status == "0000") {
            this.comsVal = result.data.data.companyName;
            this.custNo = result.data.data.custNo;
            this.uuid = result.data.data.uId;
          } else {
          }
        });
    },
    submitForm() {
      this.ajax
        .post("/jyOder/dispatchorder", {
          bizContent: {
            orderId: this.getId,
            uid: this.uuid,
            phone: this.inputVal,
            name: this.comsVal,
            custNo: this.custNo,
          },
        })
        .then((result) => {
          if (result.data.status == "0000") {
            this.dialogV = false;
            this.handleAjax();
            this.$message({
              type: "success",
              duration: 5000,
              message: "指派成功！",
              center: true,
              offset: 300,
            });
          } else {
          }
        });
    },
    changeClick() {
      let bizContent = {};
      bizContent.orderId = this.msgid;
      bizContent.sellGuarantee = this.moneyone;
      bizContent.buyGuarantee = this.moneytwo;
      bizContent.difference = this.moneytre;
      bizContent.demand = this.textVal;
      bizContent.accepttype = this.Selvalue;
      this.ajax
        .post("/jyOder/replenishorder", { bizContent })
        .then((result) => {
          if (result.data.status == "0000") {
            this.dialogMesg = false;
            this.$message({
              type: "success",
              duration: 5000,
              message: "信息补充成功！",
              center: true,
              offset: 300,
            });
            this.handleAjax();
          } else {
          }
        });
    },
  },
};
</script>

<style  scoped>
.Box {
  background: white;
  height: 883px;
}
.table {
  background: rgba(255, 255, 255, 1);
  padding-left: 31px;
  padding-right: 38px;
}
.Bot {
  height: auto;
  height: 682px;
  background: white;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.pagination {
  height: 111px;
  text-align: center;
  padding-top: 50px;
  box-sizing: border-box;
}

.Bot >>> .cell {
  font-size: 14px;
  text-align: center;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  font-family: PingFangSC-Regular, PingFang SC;
}

.button {
  padding: 12px 5px;
  border-radius: unset;
  height: 34px;
  color: #1884fc;
  background: white;
}

.line {
  width: 920px;
  height: 1px;
  box-sizing: border-box;
  background: #e3e4e5;
  margin-left: 14px;
  margin-right: 13px;
  margin-bottom: 21px;
}

.borde {
  height: 90px;
  padding-left: 34px;
  padding-top: 38px;
}
.bordeLeft {
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 33px;
}
.bordeRight {
  text-align: right;
  padding-right: 20px;
}
.rejectBtn {
  width: 56px;
  border-radius: 4px;
  color: #2b89eb;
  text-align: center;
  border: 1px solid #2b89eb;
}

.rejectDetail {
  border: none;
}

.rejectHeader {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}

.rejectReason {
  width: 500px;
  height: 148px;
  background: rgba(251, 251, 251, 1);
  margin-left: 20px;
  vertical-align: top;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 12px;
}
.dodos {
  height: 40px;
  line-height: 40px;
}
.dodovv {
  height: 40px;
  line-height: 40px;
  text-align: right;
}
.qwe >>> .el-input {
  width: 320px !important;
  margin-left: 20px;
}
.zxc >>> .el-textarea {
  width: 320px !important;
  margin-left: 20px;
}
.zxc >>> .el-input {
  width: 140px !important;
  margin-left: 20px;
}
.mnv {
  overflow: hidden;
  margin-bottom: 20px;
}
.bud {
  text-align: center;
  margin-top: 20px;
}
.butg {
  background: #3e5f9cff;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/page/orderexception/exchangetrue.vue